import { render } from "./BlogImplantsEatAnything.vue?vue&type=template&id=981d8f2a"
import script from "./BlogImplantsEatAnything.vue?vue&type=script&lang=js"
export * from "./BlogImplantsEatAnything.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__